import { Sensor } from '@/entities/sensor';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import { detailCodec, formCodec, listCodec } from './codec';
import {
  addVersionForUpdate,
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest,
  decode,
  decodeId,
  decodeVersioned,
  fetchApi,
  setBody,
  setQuery,
  Versioned,
} from '../..';
import { encodeSensorQuery, SensorQuery } from '@/services/api/resources/sensor/query';
import { filterCodec } from '@/services/api/resources/filter';

const baseUrl = '/v2/sensors';
const filterUrl = '/v2/filters/sensors';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: SensorQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeSensorQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const filter = () => pipe(
  filterUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(filterCodec)),
);

export const create = (sensor: Sensor) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(formCodec.encode(sensor))),
  chain(fetchApi),
  chain(decodeId),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(detailCodec)),
);

export const update = (id: number, sensor: Versioned<Sensor>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(sensor.version)),
  map(setBody(formCodec.encode(sensor.data))),
  chain(fetchApi),
);

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);
